// actions/salaryActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getSalaries =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "SALARY_REQUEST" });
      const { data } = await api.get("/salary", { params });
      dispatch({ type: "GET_SALARIES_SUCCESS", payload: data.salaries });
    } catch (err) {
      dispatch({ type: "SALARY_FAIL", payload: err.response?.data?.message });
    }
  };

export const processSalary = (salaryData) => async (dispatch) => {
  try {
    dispatch({ type: "SALARY_REQUEST" });
    const { data } = await api.post("/salary/process", salaryData);
    dispatch({ type: "PROCESS_SALARY_SUCCESS", payload: data.salary });
    return data;
  } catch (err) {
    dispatch({ type: "SALARY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const paySalary = (salaryData) => async (dispatch) => {
  try {
    dispatch({ type: "SALARY_REQUEST" });
    const { data } = await api.post("/salary/pay", salaryData);
    dispatch({ type: "PAY_SALARY_SUCCESS", payload: data.salary });
    return data;
  } catch (err) {
    dispatch({ type: "SALARY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const updateSalaryStatus = (id, statusData) => async (dispatch) => {
  try {
    dispatch({ type: "SALARY_REQUEST" });
    const { data } = await api.put("/salary/" + id + "/status", statusData);
    dispatch({ type: "UPDATE_SALARY_STATUS_SUCCESS", payload: data.salary });
    return data;
  } catch (err) {
    dispatch({ type: "SALARY_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};
